export default __webpack_public_path__ + "static/media/pdfDarkLogo.6e42fd58.svg";